module.exports = __webpack_public_path__ + "img/snakebite-FAQ--2.6593c8dc.jpg";